module.exports = __webpack_public_path__ + "img/02_Cladding_and_Battens_Tile.f12826bd.png";